import axios from 'axios'
import router from '../src/router'
import { baseUrl } from '/static/baseUrl'
export const myRequery = (options) => {
	return new Promise((resolve, reject) => {
		let requesturl = baseUrl +
			((options.prefix !== undefined && options.prefix !== null && options.prefix !== '') ? (options.prefix + '/') : '') +
			options.url;
		if (options.nobase) {
			requesturl = options.url;
		}
		let autherheader = sessionStorage.getItem("authToken")
		console.log(autherheader)
		axios.request({
			url: requesturl,
			method: options.method || 'GET',
			data: options.data || {},
			headers: {
				'Content-Type': 'application/json',
				Authorization: autherheader
			},
			params: options.method == 'GET' ? options.data : {},
		}).then(res => {
			console.log('获取数据：', res, requesturl);
			if (res.statusCode == 0) {
				console.log('获取数据：', res);
			} else if (res.statusCode == 401) {
				sessionStorage.setItem("authToken", '');
				router.push({ name: 'noAuth401' });
			} else {
				resolve(res.data)
			}
		}).catch(err => {
			if (err.statusCode == 401) {
				sessionStorage.setItem("authToken", '');
				router.push({ name: 'noAuth401' });
			} else {
				console.log('请求失败', err, requesturl)
				//router.push({ name: 'noAuth401' });
				//pthis.$message.error('请求失败');
				reject(err)
			}
		})
	})
}

export default myRequery